import React from 'react';
import { Modal, Button } from 'react-bootstrap';

// Same palette as the threat panels in the TM viewers.
const SEVERITY_COLOR = {
  CRITICAL: { bg: '#fde8e8', text: '#b00020' },
  HIGH:     { bg: '#fff3e0', text: '#e65100' },
  MEDIUM:   { bg: '#fffde7', text: '#f57f17' },
  LOW:      { bg: '#e8f5e9', text: '#2e7d32' },
};

/**
 * "TM Summary" pop-up of the threat-model viewers.
 * @param {object} props.summary - JSON from /website/:id/tm-summary (or the public tm-summary route):
 *   { title, website_name, version, sections: [{ id, heading, intro?, paragraphs?, items?, risks? }] }
 */
export default function TmSummaryDialog({ show, onHide, summary }) {
  if (!summary) return null;
  return (
    <Modal show={show} onHide={onHide} size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '1.1rem' }}>
          📋 {summary.title}{summary.website_name ? ` — ${summary.website_name}` : ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ fontSize: '0.9rem', color: '#222' }}>
        {summary.version && (
          <p style={{ fontSize: '0.82rem', color: '#777', fontStyle: 'italic', marginBottom: 12 }}>{summary.version}</p>
        )}
        {(summary.sections || []).map(section => (
          <div key={section.id || section.heading} style={{ marginBottom: 18 }}>
            <h6 style={{ fontWeight: 700, color: '#4527a0', marginBottom: 6 }}>{section.heading}</h6>
            {section.intro && <p style={{ marginBottom: 6, color: '#555' }}>{section.intro}</p>}
            {(section.paragraphs || []).map((p, i) => <p key={i} style={{ marginBottom: 6 }}>{p}</p>)}
            {section.items?.length > 0 && (
              <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
                {section.items.map((item, i) => <li key={i} style={{ marginBottom: 4 }}>{item}</li>)}
              </ul>
            )}
            {section.risks?.length > 0 && (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
                <thead>
                  <tr style={{ textAlign: 'left', color: '#666', borderBottom: '1px solid #ddd' }}>
                    <th style={{ padding: '4px 6px' }}>ID</th>
                    <th style={{ padding: '4px 6px' }}>Threat</th>
                    <th style={{ padding: '4px 6px' }}>Component</th>
                    <th style={{ padding: '4px 6px' }}>Severity</th>
                    <th style={{ padding: '4px 6px', textAlign: 'right' }}>Risk Score</th>
                  </tr>
                </thead>
                <tbody>
                  {section.risks.map(r => {
                    const sc = SEVERITY_COLOR[r.severity] || {};
                    return (
                      <tr key={`${r.component}-${r.id}`} style={{ borderBottom: '1px solid #f0f0f0' }}>
                        <td style={{ padding: '4px 6px', fontWeight: 600 }}>{r.id}</td>
                        <td style={{ padding: '4px 6px' }}>{r.title}</td>
                        <td style={{ padding: '4px 6px', color: '#555' }}>{r.component}</td>
                        <td style={{ padding: '4px 6px' }}>
                          <span style={{ background: sc.bg, color: sc.text, borderRadius: 4, padding: '1px 6px', fontWeight: 600, fontSize: '0.78rem' }}>
                            {r.severity}
                          </span>
                        </td>
                        <td style={{ padding: '4px 6px', textAlign: 'right' }}>{Number(r.risk_score).toFixed(2)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
